import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ExcelService } from '../../../services/excel/excel.service';
import { messages } from '../../funciones/mensajes';
import { CommonVariables, FuncionesMes } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { indProductividad } from '../idsTablas';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { FiltersM } from '../../../components/models';
import { IndicadicadoresProductividadService } from '../../../services/financiero/indicadores-productividad/indicadicadores-productividad.service';
import { companiesFinanciero } from '../../../shared/catalogos';

@Component({
  selector: 'app-indicadores-productividad',
  templateUrl: './indicadores-productividad.component.html',
  styleUrl: './indicadores-productividad.component.css'
})
export class IndicadoresProductividadComponent implements OnInit {
  @ViewChild('graficador1') graficador1: GraficadorComponent;
  @ViewChild('graficador3') graficador3: GraficadorComponent;
  @ViewChildren(GraficadorComponent) grafCmp!: QueryList<GraficadorComponent>;

  public verGraf = false;
  public Filters = FiltersM;

  public color = ['#76C4D5'];
  /* Tableros */
  private plantilla = 0;
  private idAdmin: string;
  public tipoGraf = 'area';
  public datoGraf;
  public indSelec;

  private perSelected = 0;
  private numEvaluaciones = 6;
  /*Variables filtros*/
  public Periodos = [];
  public cadenaEvaluacion = [];
  /*Titulos y subtitulos*/
  public subTitles = [];
  public subTitlesGraf = '';
  /* Datos de la plataforma */
  private variablesPeriodos = [];
  public dataTabla1 = [];
  public dataTabla1Periodos = [];

  /* Variables tabla / graficas */
  public graf1 = false;
  public titulo1Graf = '';
  public indSel1 = '';

  // Variables para el graficador
  public dataGrafica: any[] = [];
  public labelsGrafica: string[] = [];
  public axisYGrafica: string[] = [''];
  public showLabels = false;

  public headersCheck = [{ check: true }, { check: true }, { check: false }];

  public expImg1 = false; //indica si se va a exportar una grafica o la tabla de la parte superior

  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';
  public modalOpen: boolean = false;
  constructor(
    public dataService: DataService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private exportExcel: ExcelService,
    private cdr: ChangeDetectorRef,
    private indicadoresProdService: IndicadicadoresProductividadService
  ) {
    this.plantilla = Number(this.cookieService.get('idPlanFin'));    
    this.idAdmin = companiesFinanciero.find( d => d.id === this.cookieService.get("idInstitucion")).idAdmin
  }

  async ngOnInit(): Promise<void> {
    await this.getEvaluacion();
  }

  /*Consultas*/
  private async getEvaluacion() {
    try {
      const evaluaciones = await this.indicadoresProdService.getEvaluacionesByPlantilla(this.plantilla);
      this.ordenamientoDataEvaluacion([].concat(evaluaciones));
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }

  private async getDataCuentas() {
    try {
      switch(this.plantilla){
        case 7: 
          const datos = await this.indicadoresProdService.getDataCuentasMultiple(this.cadenaEvaluacion);
          await this.getDataCreditos(datos);
          break;
        case 12: 
          this.getIndicadores12();
          break;
        default:
          var nombre = companiesFinanciero.find(c => Number(c.id) === Number(this.cookieService.get('idInstitucion'))).name;
          messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
          break;
      }      
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }

  private async getDataCreditos(cuentasData: any[]) {
    try {
      const creditosData = await this.indicadoresProdService.getDataCreditosMultiple(this.cadenaEvaluacion);

      // Combinar datos de cuentas y créditos
      let datos = [];
      for (const cuenta of cuentasData) {
        const credito = creditosData.find(c => c.idEvaluacion === cuenta.idEvaluacion);
        datos.push({
          valor: cuenta.valor,
          cre_01: credito.cre_01,
          cre_02: credito.cre_02,
          cre_03: credito.cre_03,
          cre_04: credito.cre_04,
          cre_05: credito.cre_05,
          cre_06: credito.cre_06,
          cre_07: credito.cre_07,
          cre_08: credito.cre_08,
          cre_09: credito.cre_09,
          cre_10: credito.cre_10,
          cre_11: credito.cre_11,
          cre_12: credito.cre_12,
          cre_13: credito.cre_13,
          FOR_01: 199,
          FOR_02: 13,
          FOR_03: 24,
          FOR_04: 8.10,
          FOR_05: 2550307,
          idEvaluacion: cuenta.idEvaluacion,
          eval: cuenta.eval
        });
      }
      this.ordenData(datos, creditosData);
    } catch (err) {
      messages.errorMessageGraph(err);
    }
  }

  private ordenData(cuentasData: any[], creditosData: any[]) {
    let datos = [];
    for (const cuenta of cuentasData) {
      const per = this.cadenaEvaluacion.filter(val => val.idEvaluacion === cuenta.idEvaluacion)[0];
      let mes = Number(FuncionesMes.f_switchmes3(per.evaluacion.split(' ')[0]));

      datos.push({
        valCuenta: cuenta.valor,
        CRE_01: cuenta.cre_01,
        CRE_02: cuenta.cre_02,
        CRE_03: cuenta.cre_03,
        CRE_04: cuenta.cre_04,
        CRE_05: cuenta.cre_05,
        CRE_06: cuenta.cre_06,
        CRE_07: cuenta.cre_07,
        CRE_08: cuenta.cre_08,
        CRE_09: cuenta.cre_09,
        CRE_10: cuenta.cre_10,
        CRE_11: cuenta.cre_11,
        CRE_12: cuenta.cre_12,
        CRE_13: cuenta.cre_13,
        FOR_01: 199,
        FOR_02: 13,
        FOR_03: 24,
        FOR_04: 8.10,
        FOR_05: 2550307,
        idEvaluacion: cuenta.idEvaluacion,
        pos: per.pos,
        varTemp: mes,
        porcen: 100,
        eval: per.evaluacion
      });
    }

    datos.sort(function (a, b) {
      if (moment(FuncionesMes.escrituraPer(a.eval)).isAfter(moment(FuncionesMes.escrituraPer(b.eval)))) {
        return 1;
      }
      if (moment(FuncionesMes.escrituraPer(a.eval)).isBefore(moment(FuncionesMes.escrituraPer(b.eval)))) {
        return -1;
      }
      return 0;
    });

    this.variablesPeriodos = [];
    this.variablesPeriodos = datos;
    this.getIndicadores();
  }
  // Metodos calculo de indicadores PLANTILLA 7
  private getIndicadores() {
    var aux = [];
    const ind = indProductividad.indicadores(this.plantilla);
    for (const dato of ind) {
      let cal = [];

      for (const dat of this.variablesPeriodos) {
        const ev = this.cadenaEvaluacion.filter(eva => eva.idEvaluacion === dat.idEvaluacion)[0];
        cal.push({
          name: ev.evaluacion,
          valor: this.calcularInd(dato.formula, dat)
        });
      }
      aux.push({
        nombre: this.capitalizacionTexto(dato.nombre),
        descripcion: dato.calculo,
        valor: cal,
        nivel: dato.nivel,
        check: dato.nivel === 1,
        dbCheck: false,
      });
    }
    this.dataTabla1 = [];
    this.dataTabla1 = aux;
    this.getDataGraficas();
  }
  private calcularInd(formula, variables) {
    const elements = formula.split(' ');
    if (elements.length < 2) {
      return variables["" + elements[0]];
    }
    let val1 = null, val2 = null, signo = '';
    for (const elem of elements) {
      if (val1 === null) {
        val1 = variables["" + elem];
      } else if (signo === '') {
        signo = elem;
      } else if (val2 === null) {
        val2 = variables["" + elem];
        switch (signo) {
          case '/':
            val1 = val1 / val2;
            signo = '';
            val2 = null;
            break;
          case '*':
            val1 = val1 * val2;
            signo = '';
            val2 = null;
            break;
          case '+':
            val1 = val1 + val2;
            signo = '';
            val2 = null;
            break;
          case '-':
            val1 = val1 - val2;
            signo = '';
            val2 = null;
            break;
        }
      }
    }
    return Number(val1.toFixed(1));
  }
  private getDataGraficas() {
    let aux = [], auxDta = [];
    const ind = indProductividad.indicadores(this.plantilla);
    for (const dato of ind) {
      for (const dat of this.variablesPeriodos) {
        const per = this.cadenaEvaluacion.filter(eva => eva.idEvaluacion === dat.idEvaluacion)[0].evaluacion;
        let cal = this.calcularInd(dato.formula, dat);
        auxDta.push({
          value: cal,
          name: per,
        })
      }
      aux.push({
        nombre: this.capitalizacionTexto(dato.nombre),
        valor: auxDta,
      });
      auxDta = [];
    }
    this.dataTabla1Periodos = [];
    this.dataTabla1Periodos = aux;

    // Inicializar la primera gráfica
    if (this.dataTabla1Periodos.length > 0 && this.dataTabla1.length > 0) {
      this.changeGrafic1(this.tipoGraf, this.dataTabla1Periodos[0], this.dataTabla1[0].nombre);
    }
  }
  // Metodos de calculo de indicadores PLANTILLA 12 
  private async getDataCuentas12(){
    var periodos = this.cadenaEvaluacion.map(p => ({anio: p.an, mes: Number(p.mes)}));
    var variablesAT = indProductividad.variablesAT(this.plantilla);
    const subcalculos = await this.indicadoresProdService.getDataIndicadores(this.idAdmin, periodos);
    const subcalculosMap = new Map<string, any>();
    subcalculos.forEach(s => {
      subcalculosMap.set(`${s.anio}-${s.mes}`, { ...s });
    });
    for (const c of this.cadenaEvaluacion) {
      const key = `${c.an}-${Number(c.mes)}`;
      const sub = subcalculosMap.get(key);

      if (!sub) continue;

      for (const v of variablesAT) {
        const d = await this.indicadoresProdService
          .getVariable(c.idEvaluacion, v);
        sub[d.detalleEvaluacionVariable.idVariable] = d.detalleEvaluacionVariable.valor;
      }
      const cuenta = await this.indicadoresProdService.getDetalleCuenta(c.idEvaluacion, 'G704');
      sub[cuenta.detalleEvaluacionCuenta.idCuenta] = cuenta.detalleEvaluacionCuenta.valor;
    }
    this.variablesPeriodos = Array.from(subcalculosMap.values());
  }
  private async getIndicadores12(){
    var aux = [];
    const ind = indProductividad.indicadores(this.plantilla);
    await this.getDataCuentas12();
    for (const dato of ind) {
      let cal = [];
      
      for (const dat of this.variablesPeriodos) {
        var bnd = false, indValor = 0;
        if(dato.nombre === 'Costo operativo por crédito vigente'){
          bnd = true;
          const cierreAnterior = (await this.indicadoresProdService.getDataIndicadores(this.idAdmin, [{anio: dat.anio-1, mes: 12}]))[0]?.numeroCreditosVigentes ?? 0;
          indValor = (dat.G704 / dat.mes * 12) / ((dat['numeroCreditosVigentes'] + cierreAnterior) / 2);
        }else if(dato.nombre === 'Cartera bruta sin tarjetas de crédito'){
          bnd = true;
          const cierreAnterior = (await this.indicadoresProdService.getDataIndicadores(this.idAdmin, [{anio: dat.anio-1, mes: 12}]))[0]?.numeroCreditosVigentes ?? 0;
          indValor = (dat.G704 / dat.mes * 12);
        }else if(dato.nombre === 'Número de empleados'){
          bnd = true;
          const cierreAnterior = (await this.indicadoresProdService.getDataIndicadores(this.idAdmin, [{anio: dat.anio-1, mes: 12}]))[0]?.numeroCreditosVigentes ?? 0;
          indValor = ((dat['numeroCreditosVigentes'] + cierreAnterior) / 2);
        }
        const ev = this.cadenaEvaluacion.filter(eva => {
          return eva.an === dat.anio && Number(eva.mes) === dat.mes;
        })[0];
        cal.push({
          name: ev.evaluacion,
          valor: !bnd ? this.calcularInd12(dato.formula, dat) : Number(indValor.toFixed(1)),
        });
      }
      aux.push({
        nombre: this.capitalizacionTexto(dato.nombre),
        descripcion: dato.calculo,
        valor: cal,
        nivel: dato.nivel,
        check: dato.nivel === 1,
        dbCheck: false
      });
    }
    this.dataTabla1 = aux;
    this.getDataGraficas12();
  }
  private getDataGraficas12() {
    let aux = [], auxDta = [];
    const ind = indProductividad.indicadores(this.plantilla);
    for (const dato of ind) {
      for (const dat of this.variablesPeriodos) {
        const per = this.cadenaEvaluacion.filter(eva => eva.an === dat.anio && Number(eva.mes) === dat.mes)[0].evaluacion;
        let cal = this.calcularInd(dato.formula, dat);
        auxDta.push({
          value: cal,
          name: per,
        })
      }
      aux.push({
        nombre: this.capitalizacionTexto(dato.nombre),
        valor: auxDta,
      });
      auxDta = [];
    }
    this.dataTabla1Periodos = [];
    this.dataTabla1Periodos = aux;

    // Inicializar la primera gráfica
    if (this.dataTabla1Periodos.length > 0 && this.dataTabla1.length > 0) {
      this.changeGrafic1(this.tipoGraf, this.dataTabla1Periodos[0], this.dataTabla1[0].nombre);
    }
  }
  private calcularInd12(formula, variables) {
    const elements = formula.split(' ');
    if (elements.length < 2) {
      return variables["" + elements[0]];
    }
    let val1 = null, val2 = null, signo = '';
    for (const elem of elements) {
      if (val1 === null) {
        val1 = variables["" + elem];
      } else if (signo === '') {
        signo = elem;
      } else if (val2 === null) {
        val2 = variables["" + elem];
        switch (signo) {
          case '/':
            val1 = val1 / val2;
            signo = '';
            val2 = null;
            break;
          case '*':
            val1 = val1 * val2;
            signo = '';
            val2 = null;
            break;
          case '+':
            val1 = val1 + val2;
            signo = '';
            val2 = null;
            break;
          case '-':
            val1 = val1 - val2;
            signo = '';
            val2 = null;
            break;
        }
      }
    }
    return Number(val1.toFixed(1));
  }
  //-----------------------------------------------------------------
  /*Obtención de datos*/
  private ordenamientoDataEvaluacion(datos) {
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for (const an of this.Periodos) {
      if (an.anio < 2023) {
        an.visible = false;
      }
    }
    this.perSelected = info.perSel;
    this.obtenerDataEvaluacion();
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion() {
    this.cadenaEvaluacion = [];
    this.subTitles = [];
    var tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      if (this.Periodos[i].visible) {
        for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
          if (this.Periodos[i].series[j].check) {
            this.cadenaEvaluacion.push({
              evaluacion: this.Periodos[i].series[j].periodo,
              idEvaluacion: this.Periodos[i].series[j].id,
              porcentaje: '%',
              pos: this.Periodos[i].series[j].pos,
              an: this.Periodos[i].series[j].an,
              mes: FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes)
            });
            tot++;
          }
        }
      }
    }
    var i = 0;
    for (var j = this.cadenaEvaluacion.length - 1; j >= 0; j--) {
      if (i === 0) {
        this.subTitles.push(this.cadenaEvaluacion[j].evaluacion);
      } else {
        this.subTitles.push(' | ')
        this.subTitles.push(this.cadenaEvaluacion[j].evaluacion);
      }
      i++
    }
    
    this.getDataCuentas();
  }
  /* acciones en filtros */
  public numPerSelect() {
    var selecc = 0;
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.check) {
          selecc++;
        }
      }
    }
    if (selecc > 1)
      return true;
    return false;
  }
  public cambioPeriodo(per) {
    if (per.check || (!per.check && this.periodosSeleccionadosAct() < this.numEvaluaciones)) {
      per.check = !per.check;
      this.cadenaEvaluacion = [];
      this.subTitles = [];
      this.perSelected = 0;
      var i = 0, cadena = '';
      for (const an of this.Periodos) {
        for (const mes of an.series) {
          if (mes.check) {
            this.perSelected++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if (i === 0) {
              this.subTitles.push(mes.periodo);
              cadena = '' + mes.id;
            } else {
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ',' + mes.id;
            }
            i++;
          }
        }
      }
      this.obtenerDataEvaluacion();
      //this.getDataCuentas();
    } else {
      per.check = false;
      messages.infoMessageGraph('No se pueden seleccionar más de ' + this.perSelected + ' periodos');
    }
  }

  private periodosSeleccionadosAct() {
    var sel = 0;
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.check) {
          sel++;
        }
      }
    }
    return sel;
  }


  /* cambio de graficas */
  public changeGrafic1(val, dat?, pos?, click?) {
    this.datoGraf = dat;
    this.tipoGraf = val;
    this.indSelec = pos;
    this.expImg1 = !this.expImg1;

    const indG = this.dataTabla1.find(ind => ind.nombre === pos);
    if(indG.nivel === 1 && click){
      indG.dbCheck = !indG.dbCheck;
      const index = this.dataTabla1.findIndex(ind => ind.nombre === pos);
      for(var i = index+1; i <= this.dataTabla1.length-1; i++){
        if(this.dataTabla1[i].nivel === 1){
          break;
        }
        this.dataTabla1[i].check = !this.dataTabla1[i].check;
      }
    }

    // Preparar datos para el graficador
    if (dat) {
      this.prepararDatosGrafica(dat, val);
    }
  }

  private prepararDatosGrafica(arreglo, tipo) {
    if (!arreglo || !arreglo.valor) {
      return;
    }

    let values = [];
    let categories = [];

    for (const dat of arreglo.valor) {
      values.push(dat.value);
      categories.push(dat.name);
    }

    // Asegúrate de que hay datos antes de asignar
    if (values.length === 0) {
      return;
    }

    this.dataGrafica = [{
      name: this.capitalizacionTexto(arreglo.nombre),
      data: values,
    }];

    this.labelsGrafica = categories;
    this.axisYGrafica = [this.capitalizacionTexto(arreglo.nombre)];
    this.indSel1 = this.capitalizacionTexto(arreglo.nombre);
    this.verGraf = true;

    // Forzar detección de cambios
    this.cdr.detectChanges();
  }
  // Método para exportar la gráfica
  public exportarGraficaImg() {
    const periodo = this.subTitles.map(per => this.escrituraPer(per)).join('');
    const titulos = {
      titulo: this.translate.instant('financiero.indicadoresProductividad.tituloTabla11'),
      subtitulo: this.indSel1 + ' ' + periodo,
      nombreArch: this.translate.instant('financiero.indicadoresProductividad.tituloTabla11') + ' ' +
        this.indSel1 + ' ' + this.escrituraPer(this.subTitles[this.subTitles.length - 1])
    };

    this.graficador1.exportImg(1, titulos);
  }
  /* formateo de datos */
  public escrituraPer(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    }
    return Periodo;
  }
  /* Modales */
  public openModal(modal) {
    if (!this.verGraf) {
      messages.infoMessageGraph(this.translate.instant('financiero.indicadoresProductividad.modalWarning'));
      return;
    }
    this.modalOpen = true
    switch (modal) {
      case 'graf1':
        this.graf1 = true;
        break;
    }
  }
  /* Exportación */
  public exportarExcelTab1() {
    var headers = [], i = 0;
    headers.push(this.translate.instant('financiero.indicadoresProductividad.titTabla2'));
    for (const head of this.dataTabla1[0].valor) {
      headers.push(this.escrituraPer(head.name));
    }

    var data = [];
    i = 0;
    for (const val of this.dataTabla1) {
      var aux = [];
      // if (i < 9) {
      //   aux.push('CR_0' + (i + 1));
      // } else {
      //   aux.push('TC_' + (i + 1));
      // }
      aux.push(val.nombre);
      if (this.headersCheck[2].check) {
        aux.push(val.descripcion);
      }
      for (const dat of val.valor) {
        if (dat.valor < 10000) {
          aux.push(dat.valor);
        } else {
          aux.push(Number((dat.valor).toFixed(0)));
        }
      }
      i++;
      data.push(aux);
    }

    let titulo = `${this.translate.instant('financiero.indicadoresProductividad.tituloTabla1')} ${this.indSel1} `;
    for (const per of this.subTitles) {
      titulo += this.escrituraPer(per);
    }

    this.exportExcel.excelFinancieroIndProd(titulo, headers, data, this.translate.instant('financiero.indicadoresProductividad.tituloTabla1') + " " + this.escrituraPer(this.subTitles[this.subTitles.length - 1]));
  }

  //exportar grafica en imagen 
  public exportarGrafica(id, nombre) {
    var periodo = '';
    for (const per of this.subTitles) {
      periodo += this.escrituraPer(per);
    }
    var name = { 
      titulo: this.translate.instant('financiero.indicadoresProductividad.tituloTabla11') + " | " + this.translate.instant(nombre) + " " + this.indSel1,
      subtitulo:  periodo,
      nombreArch: this.indSel1
    }    
    const comp = this.grafCmp.find(g => g.zona === id);
    comp.exportImg(id,name);
  }

  public capitalizacionTexto(text: string): string | undefined {
    if (!text) return undefined;
    text = text.trim();
    if (text.endsWith('.')) text = text.slice(0, -1);
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }

  public borrarFiltro() {
    this.Periodos = [];
    this.cadenaEvaluacion = [];
    this.getEvaluacion();
  }
}
